export default __webpack_public_path__ + "static/21-4c221e6010a727538703aa42ea401b59.webp";